import { InputProps, Input } from "@repo/ui"
import { useState } from "react"
import { cn } from "@/lib/utils"

// TODO: Questo componente è orribile
export const PasswordInput = ({
  ref,
  ...props
}: React.ComponentPropsWithRef<"input"> & InputProps) => {
  const [isPasswordRevealed, setIsPasswordRevealed] = useState(false)
  const toggleIsPasswordRevealed = () =>
    setIsPasswordRevealed(!isPasswordRevealed)
  const { className, ...rest } = props
  return (
    <div className="flex">
      <Input
        autoComplete="new-password"
        {...rest}
        className={cn(
          className,
          `border-gray-200 border px-2 border-r-0 rounded-tr-none rounded-br-none`
        )}
        ref={ref}
        type={isPasswordRevealed ? `text` : `password`}
      />
      <button
        type="button"
        className="border-gray-200 border rounded px-2 border-l-0 rounded-tl-none rounded-bl-none"
        aria-label={isPasswordRevealed ? `Hide password` : `Show password`}
        aria-controls={props.id}
        onClick={toggleIsPasswordRevealed}
      >
        <span className="text-sm">{isPasswordRevealed ? `Hide` : `Show`}</span>
      </button>
    </div>
  )
}

PasswordInput.displayName = `PasswordInput`
